module.exports = __webpack_public_path__ + "static/media/linked-in-black.7e367afa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/linked-in-black.svg
// module id = 333
// module chunks = 0